import Vue from 'vue';
import Vuex from 'vuex';

//import modules from './modules';

Vue.use(Vuex);

const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGOUT = 'LOGOUT';
const SET_ROLE = 'SET_ROLE';
const DYN_CON_DONE = 'DYN_CON_DONE';
const DYN_CONTENT_LOADED = 'DYN_CONTENT_LOADED';

export default new Vuex.Store({
    state: {
        lngFront: 'fr',
        menuFrontExpanded: false,
        contents: [],
        selects: [],
       isDynContentLoaded: false,
        isLoggedIn: false,
        window: {width:''},
        userRole: null,
        appRootPath: null,
        UserLogin: null,
        navProjects:{cat: '', heading:'', active: false},        
    },
    getters: {
        getWindowSize(state) {
            return state.window;
        },
        
        getUserRole(state) {
            return state.userRole;
        },
        getContents(state) {
            return state.contents;
        },
        isDynContLoaded(state){
           return state.isDynContentLoaded;
        },
        currentLng(state){
            return state.lngFront;
        }
    },
    mutations: {
        [DYN_CONTENT_LOADED] (state) {
            state.isDynContentLoaded = true;
        },
        [LOGIN_SUCCESS](state, login) {
            state.isLoggedIn = true;
            state.UserLogin = login;
        },
        [SET_ROLE](state, userRight) {
            switch (userRight) {
                /*
                case 'admin':
                    state.userRole = 'admin';
                    state.appRootPath = '/admin/dashboard';
                    state.isAdmin = true;
                    break;*/
                default:
                    state.userRole = 'admin';
                    state.appRootPath = '/admin/dashboard';
                    //state.isAdmin = true;
                    break;
            }
            return state.userRole
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
            state.userRole = null;
            state.appRootPath = '/';
            state.isAdmin = false;
        },
        /*
        [DYN_CON_DONE](state) {
            state.isDynContentLoaded = true;
        },*/
        
    },
    actions: {
        login({ state, commit }, creds) {
            //console.log("actions: login");
            commit(LOGIN_SUCCESS, creds.login);
            commit(SET_ROLE, creds.user_right);
            // FIXME: transform this into a promise for more control
            // return new Promise(resolve => {
            //   resolve();
            // });
        },
        logout({ state, commit }) {
            commit(LOGOUT);
        },
        
        dynContentLoaded({ state, commit }) {
            commit(DYN_CONTENT_LOADED);
        }
    },
    //modules
});



// WEBPACK FOOTER //
// ./src/store/index.js